// CTA at the end of legacy comparison table
function scrollToTop() {
  const targetDiv = document.getElementById('variant-select');
  if (targetDiv) {
    console.log("top scrollo");
    targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

